'use client'

import {
  Box,
  Heading,
  Container,
  Text,
  Button,
  Stack,
} from '@chakra-ui/react'
import { useNavigate } from "react-router-dom";

export default function Hero() {
  const navigate = useNavigate(); // Initialize the navigate function
  return (
    <>
      <Container maxW={'3xl'} >
        <Stack
          as={Box}
          textAlign={'center'}
          spacing={{ base: 8, md: 14 }}
          py={{ base: 6, md: 36 }}
          //py={8}
          >
          <Heading
            fontWeight={600}
            fontSize={{ base: '2xl', sm: '4xl', md: '6xl' }}
            lineHeight={'110%'}>
            Capture Moments Instantly, <br />
            <Text as={'span'}
             bgClip='text'  
             _hover={{bgGradient: 'linear(to-r, red.500, purple.500)'}} 
             bgGradient={[
                'linear(to-r, #FF0080, #7928CA 130%)',   
            ]}>
            With Photographers You Can Trust
            </Text>
          </Heading>
          <Text color={'white.500'}>
            Book professional photographers on-demand, anywhere, anytime. 
            Whether it's a last-minute request or a planned shoot, 
            we ensure your moments are captured with confidence.
            Pricing is subjected to photographer's hourly rate, and prices are in USD.
            Establishing trust, payments are securely held in Stripe and only released once you're satisfied with the photos.
          </Text>
          <Stack
            direction={'column'}
            spacing={3}
            align={'center'}
            alignSelf={'center'}
            position={'relative'}>
            <Button
              colorScheme={'green'}
              bg={'green.400'}
              rounded={'full'}
              textColor={'white'}
              bgGradient={'linear(to-b, #FF0080 40%, #7928CA )'}
              px={6}
              _hover={{
                bg: 'green.500',
                bgGradient: 'linear(to-r, red.500, purple.500)'
              }}
              onClick={() => {
                // Check if the user is logged in
              const isLoggedIn = !!localStorage.getItem('token'); // Replace with your login token or authentication check
              navigate(isLoggedIn ? '/search' : '/login');}}
              >
              Find Your Photographer Now
            </Button>
            <Button variant={'link'} colorScheme={'blue'} size={'sm'}>
              Learn more
            </Button>
          </Stack>
        </Stack>
      </Container>
    </>
  )
}


